import React, {useEffect, useId, useState} from 'react';
import {Autocomplete, Box, Checkbox, Chip, InputAdornment, TextField} from '@mui/material';
import {reportingFilterInputStyles, reportingMenuPaperStyles} from './ReportingToolbarDesign';

export default function ReportMultiSelectFilter({value = [], onChange, loadOptions, label, getLabel, equal, startIcon}) {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState('');
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const id = useId();
    useEffect(() => {
        if (!open) {setSearch(''); return;}
        let active = true;
        setLoading(true);
        setError(false);
        const timer = setTimeout(async () => {
            try {
                const result = await loadOptions(search);
                if (active) setOptions(result);
            } catch {
                if (active) {setOptions([]); setError(true);}
            } finally {if (active) setLoading(false);}
        }, search ? 300 : 0);
        return () => {active = false; clearTimeout(timer);};
    }, [open, search, loadOptions]);
    return <Autocomplete id={id} multiple disableCloseOnSelect fullWidth open={open} onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)} value={value || []} onChange={(event, selected) => onChange(selected)}
        inputValue={search} onInputChange={(event, next) => setSearch(next)} options={options} loading={loading}
        noOptionsText={error ? 'Unable to load options. Try searching again.' : 'No options found'}
        getOptionLabel={getLabel} isOptionEqualToValue={equal}
        slotProps={{paper: {sx: {...reportingMenuPaperStyles, width: 'auto'}}}}
        renderOption={({key, ...props}, option, {selected}) => <li key={key} {...props}>
            <Checkbox checked={selected} size="small" sx={{p: 0.5, mr: 0.5}}/>{getLabel(option)}
        </li>}
        renderValue={(selected, getItemProps) => <Box sx={{display: 'flex', alignItems: 'center', gap: 0.5,
            flex: '0 1 auto', minWidth: 0, maxWidth: 'calc(100% - 30px)'}}>
            {selected.slice(0, 1).map((option, index) => {
                const {key, ...props} = getItemProps({index});
                return <Chip key={key} {...props} size="small" label={getLabel(option)} sx={{minWidth: 0, maxWidth: '100%'}}/>;
            })}
            {selected.length > 1 && <Box component="span" sx={{flexShrink: 0, fontSize: 12, whiteSpace: 'nowrap'}}>+{selected.length - 1}</Box>}
        </Box>}
        renderInput={params => <TextField {...params} size="small" placeholder={value?.length ? '' : label}
            sx={{...reportingFilterInputStyles,
                '& .MuiOutlinedInput-root.MuiAutocomplete-inputRoot': {
                    ...reportingFilterInputStyles['& .MuiOutlinedInput-root.MuiAutocomplete-inputRoot'],
                    flexWrap: 'nowrap'
                },
                '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
                    flex: '1 1 0', minWidth: open ? 60 : 0
                }
            }} slotProps={{htmlInput: {...params.inputProps, 'aria-label': label},
                input: {...params.InputProps, startAdornment: startIcon ? <>
                    <InputAdornment position="start">{startIcon}</InputAdornment>
                    {params.InputProps.startAdornment}
                </> : params.InputProps.startAdornment}}}/>}/>;
}
